/**
 * 将给定的数字格式化为标准的千位数字
 * @param value 要格式化的数字
 * @example $thousand(10000) => '10,000'
 */
export default function (value: number){
	return (+parseInt(String(+value)) || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}
